import React from 'react';
import { useMobile } from '../../../../hooks/useMobile';
import { Scroll } from '../../../../utils';
import { CustomDialogProps } from './types/dialog-props';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Banner from './Banner';
import Header from './Header';
import Description from './Description';
import InfoNote from '../../Notes/InfoNote';
import { Slide } from '@material-ui/core';

const useStyles = makeStyles((theme: any) => ({
  root: {
    textAlign: 'center',
    '& .MuiDialog-paper': {
      overflow: 'hidden',
      borderRadius: ({ mobile }: { mobile: boolean }) =>
        mobile ? 0 : theme.spacing(1),
      overflowY: 'initial',
      padding: 0,
      width: '100%',
      marginTop: ({ bannerSize }: any) => bannerSize,
      maxWidth: ({ maxWidth }: any) => maxWidth,
    },
  },
  content: {
    paddingBottom: ({ actions }: any) => (actions ? 0 : theme.spacing(4)),
    overflow: 'unset',
  },
  actions: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiButtonBase-root': { minWidth: 140 },
    '& .MuiButton-label': { fontSize: 20 },
  },
  paddingRightAndLeft: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
  note: { marginTop: theme.spacing(6) },
}));

const bannerSize = 36;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...(props as any)} />;
});

export default function CustomDialog({
  open,
  header,
  description = null,
  children,
  actions = null,
  onClose = null,
  onSubmit = null,
  maxWidth = 600,
  scroll = Scroll.body,
  info = null,
  customContent = false,
  isDescriptionInHeader = false,
  headerPadding = undefined,
  bannerElement = null,
  ...rest
}: CustomDialogProps) {
  const mobile = useMobile('sm');
  const classes = useStyles({
    maxWidth,
    mobile,
    bannerSize: mobile && !bannerElement ? 0 : bannerSize,
    actions: actions ? true : false,
  });

  if (mobile) {
    rest['TransitionComponent'] = Transition;
    headerPadding = 2;
  }

  return (
    <Dialog
      open={open}
      className={classes.root}
      disableRestoreFocus
      onClose={onClose}
      scroll={scroll}
      fullScreen={mobile}
      {...rest}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        {bannerElement && bannerElement}
        {!bannerElement && <Banner bannerSize={bannerSize} onClose={onClose} />}
        {customContent && <>{children}</>}
        {!customContent && (
          <>
            <Header
              header={header}
              description={isDescriptionInHeader ? description : null}
              customPadding={headerPadding}
            />
            <DialogContent
              className={classes.content + ' ' + classes.paddingRightAndLeft}
            >
              {!isDescriptionInHeader && (
                <Description description={description} />
              )}
              {children}
              {info && (
                <div className={classes.note}>
                  <InfoNote text={info} />
                </div>
              )}
            </DialogContent>
            {actions && (
              <DialogActions
                className={classes.actions + ' ' + classes.paddingRightAndLeft}
              >
                {actions}
              </DialogActions>
            )}
          </>
        )}
      </form>
    </Dialog>
  );
}
